import React from 'react';
import MaintenanceLayout from '@app/layout/MaintenanceLayout';

const MaintenancePage: React.FC = () => {
  return <MaintenanceLayout title="Ringil - Maintenance" />;
};

export default MaintenancePage;
